export default {
    replacementProduct: '',
    selectedCurtains:'',
    curtainArea:'',
    replacementProducts:'',
    replacementProductPrice:0,
    replacementStripLengthInc:0,
    replacementStripLengthFeet:0,
    replacementStripQty:0,
    replacementProductCode:'',
    fourInchIengths:{
        low:1,
        heigh:300,
        type:"4 INCH"
    },
    sixInchIengths:{
        low:1,
        heigh:300,
        type:"6 INCH"
    },
    eightInchIengths:{
        low:1,
        heigh:300,
        type:"8 INCH"
    },
    twelveInchIengths:{
        low:1,
        heigh:200,
        type:"12 INCH"
    },
    stripLengthValidationMsg:false,
    stripReplacementType:''
}